document.addEventListener("DOMContentLoaded", function () {
  if (window.matchMedia("(hover: none)").matches) return;

  const header = document.querySelector('.header');
  const items = document.querySelectorAll(".header__links-list > li");

  // CRITICAL: Remove any theme-applied 'active' classes on page load.
  // This prevents the theme from thinking a menu is already "open" or "sticky" 
  // just because we are on that page, which often blocks the hover animation.
  document.querySelectorAll('.mega-nav.active').forEach(nav => {
    nav.classList.remove('active', 'visible');
  });

  items.forEach((li) => {
    const trigger = li.querySelector(':scope > a[data-mega]');
    const mega = li.querySelector(':scope > nav.mega-nav');
    const container = li.querySelector('.mega-nav__container');
    const overlay = li.querySelector('.mega-nav__overlay');

    if (!trigger || !mega || !container) return;

    let closeTimer;

    const openMega = () => {
      clearTimeout(closeTimer);
      
      // Close other mega menus
      document.querySelectorAll(".mega-nav.active").forEach(otherMega => {
         if (otherMega !== mega) {
            otherMega.classList.remove('visible', 'active');
         }
      });

      // Force classes regardless of whether they exist (overrides theme blocks)
      mega.classList.add("active");
      // Tiny delay to ensure the display change (active) is registered before opacity (visible)
      requestAnimationFrame(() => {
        mega.classList.add("visible");
      });
    };

    const closeMega = () => {
      mega.classList.remove("visible");
      setTimeout(() => {
        if (!mega.classList.contains('visible')) {
          mega.classList.remove("active");
        }
      }, 250);
    };

    /* HOVER LOGIC - Applying to the LI ensures the whole area is covered */
    li.addEventListener("mouseenter", openMega);
    li.addEventListener("mouseleave", () => {
      closeTimer = setTimeout(closeMega, 150);
    });

    // Keep menu open while hovering inside it
    container.addEventListener("mouseenter", () => clearTimeout(closeTimer));
    container.addEventListener("mouseleave", () => {
      closeTimer = setTimeout(closeMega, 150);
    });

    /* INTERNAL MEGA NAV HOVER LOGIC */
    container.addEventListener('mouseover', (event) => {
      const a = event.target.closest('.mega-nav__item > a');
      if (!a) return;

      const triggerAttr = a.getAttribute('data-trigger');
      const collection = a.getAttribute('data-collection');
      
      const imageContainer = container.querySelector('[data-image]');
      const allImages = container.querySelectorAll('.image');
      const defaultImage = container.querySelector('.image--mega-nav-image');
      const submenus = container.querySelectorAll('.mega-nav__list[data-depth="1"]');

      if (triggerAttr) {
        submenus.forEach(sub => {
          if (sub.getAttribute('data-submenu') === triggerAttr) {
            sub.classList.add('visible');
          } else {
            sub.classList.remove('visible');
          }
        });
        if (imageContainer) imageContainer.classList.remove('visible');
        allImages.forEach(img => img.classList.remove('active'));
      } 
      else if (collection) {
        const targetImg = container.querySelector('.image--' + collection);
        submenus.forEach(sub => sub.classList.remove('visible'));
        allImages.forEach(img => img.classList.remove('active'));
        if (targetImg) {
          targetImg.classList.add('active');
          if (imageContainer) imageContainer.classList.add('visible');
        } else if (defaultImage) {
          defaultImage.classList.add('active');
          if (imageContainer) imageContainer.classList.add('visible');
        }
      }
    });

    if (overlay) {
      overlay.addEventListener("mouseenter", () => {
        clearTimeout(closeTimer);
        closeMega();
      });
    }
  });

  if (header) {
    header.addEventListener('mouseleave', () => {
       document.querySelectorAll('.mega-nav.active').forEach(nav => {
         nav.classList.remove('visible');
         setTimeout(() => nav.classList.remove('active'), 250);
       });
    });
  }
});

/**
 * Optimized Cart Inventory & Remove Button Fixes
 */
(function() {
  let inventoryData = {};
  let currentCart = {};
  let isSyncing = false;

  async function syncInventory() {
    if (isSyncing) return;
    isSyncing = true;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      currentCart = {};
      const handles = new Set();

      cart.items.forEach(item => {
        currentCart[item.variant_id] = item.quantity;
        handles.add(item.handle);
      });

      await Promise.all([...handles].map(async handle => {
        if (inventoryData[handle] && typeof inventoryData[handle] === 'object') return;
        try {
          const pRes = await fetch(`/products/${handle}.js`);
          const product = await pRes.json();
          product.variants.forEach(v => {
            inventoryData[v.id] = {
              max: v.inventory_quantity,
              policy: v.inventory_policy,
              mgmt: v.inventory_management,
              title: v.title
            };
          });
          inventoryData[handle] = true;
        } catch (err) {}
      }));
      
      applyCustomizations();
    } catch (e) {
      console.warn("Cart sync failed", e);
    } finally {
      isSyncing = false;
    }
  }

  function applyCustomizations() {
    const items = document.querySelectorAll('.quick-cart__item');
    if (!items.length) return;

    items.forEach(item => {
      const vid = item.getAttribute('data-id');
      const container = item.querySelector('.quick-cart__item-right');
      const incBtn = item.querySelector('[data-increase]');
      const data = inventoryData[vid];

      if (!container) return;

      if (!container.querySelector('.custom-remove-link')) {
        const title = container.querySelector('h4');
        const rBtn = document.createElement('button');
        rBtn.type = 'button';
        rBtn.className = 'custom-remove-link';
        rBtn.innerText = 'Remove';
        rBtn.style.cssText = 'background:none; border:none; padding:0; cursor:pointer; font-size:11px; text-decoration:underline; display:block; margin-bottom:10px; color:#fff; opacity:0.6;';
        rBtn.onclick = (e) => {
          e.preventDefault();
          item.style.opacity = '0.3';
          fetch('/cart/change.js', { 
             method: 'POST', 
             headers: {'Content-Type': 'application/json'}, 
             body: JSON.stringify({id: vid, quantity: 0}) 
          }).then(res => res.json()).then(cart => {
             document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
             if (item.parentNode) item.remove();
          });
        };
        if (title) title.after(rBtn);
      }

      if (data && data.mgmt === 'shopify' && data.policy === 'deny') {
        const domQty = parseInt(item.querySelector('[data-qty]')?.innerText || 0);
        const actualQty = Math.max(domQty, currentCart[vid] || 0);

        if (actualQty >= data.max) {
          if (incBtn) {
            incBtn.style.opacity = '0.1';
            incBtn.style.pointerEvents = 'none';
          }
          if (!container.querySelector('.stock-notice')) {
            const notice = document.createElement('div');
            notice.className = 'stock-notice';
            notice.innerText = 'MAX STOCK REACHED';
            notice.style.cssText = 'color:#e00; font-size:10px; font-weight:bold; margin-top:2px; letter-spacing:0.5px;';
            container.appendChild(notice);
          }
        } else {
          if (incBtn) {
            incBtn.style.opacity = '1';
            incBtn.style.pointerEvents = 'auto';
          }
          const exNotice = container.querySelector('.stock-notice');
          if (exNotice) exNotice.remove();
        }
      }
    });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-increase]');
    if (btn) {
      const vid = btn.getAttribute('data-increase');
      const data = inventoryData[vid];
      const qtyTxt = btn.parentNode.querySelector('[data-qty]');
      const domQty = qtyTxt ? parseInt(qtyTxt.innerText) : 0;
      
      if (data && data.mgmt === 'shopify' && data.policy === 'deny') {
        if (domQty >= data.max) {
          e.preventDefault();
          e.stopImmediatePropagation();
          alert("Only " + data.max + " items in stock.");
          return false;
        }
      }
    }
  }, true);

  document.addEventListener('DOMContentLoaded', syncInventory);
  document.addEventListener('cart:open', syncInventory);
  document.addEventListener('cart:updated', () => { syncInventory(); });

  const obs = new MutationObserver(() => applyCustomizations());
  obs.observe(document.body, { childList: true, subtree: true });

})();